import { Splide, SplideSlide } from '@splidejs/react-splide';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import CarouselSlide from './CarouselSlide';
import { CAROUSEL_OPTIONS } from './constants';

const Carousel = ({ carouselRef, onCarouselSlideChange, selectedStore, sortedStores }) => {
  const carouselKey = useMemo(
    () => sortedStores.map(store => store.handle).join('-'),
    [sortedStores]
  );

  return (
    <Splide
      key={carouselKey}
      ref={carouselRef}
      className="visible absolute inset-x-0 bottom-4 z-30 md:bottom-0 md:left-3 md:right-3 md:top-[56px] md:w-[366px] md:shadow-md"
      options={CAROUSEL_OPTIONS}
      onMove={onCarouselSlideChange}
    >
      {sortedStores.map(store => (
        <SplideSlide key={store.handle} className="">
          <CarouselSlide {...store} selectedStore={selectedStore} />
        </SplideSlide>
      ))}
    </Splide>
  );
};

Carousel.propTypes = {
  carouselRef: PropTypes.shape({
    current: PropTypes.object,
  }).isRequired,
  onCarouselSlideChange: PropTypes.func.isRequired,
  selectedStore: PropTypes.object,
  sortedStores: PropTypes.array.isRequired,
};

export default Carousel;
